export class ExternalInteractorBase {
    constructor(container) {
        this.type = "external";
        this.container = container;
    }
}
